import setupSlider from './common/slider';

const SELECTORS = Selectors({
  slide: '[data-blog-slide]',
  slider: '.latest-blogs__slider',
});

const slides = document.querySelectorAll(SELECTORS.slide);

const fn = {
  init: () => {
    fn.setupBlogSlider();
  },

  setupBlogSlider: () => {
    const slider = document.querySelector(SELECTORS.slider);
    const options = {
      type: 'carousel',
      perView: 3,
      focusAt: 0,
      breakpoints: {
        1200: {
          type: 'carousel',
          perView: 2,
          focusAt: 0,
          startAt: 0,
        },
        768: {
          type: 'carousel',
          perView: 1,
        },
      },
    };
    setupSlider(slider, options);
  },
};

export default {
  can: () => slides.length,
  run: fn.init,
};
